import SeriesInfoApi from '../api/SeriesInfoApi';
import SeriesInfoConstants from '../constants/SeriesInfoConstants';

function fetchSeriesInfo(metadataId) {
  return {
    types: [
      SeriesInfoConstants.FETCH_SAME_SERIES_REQUEST,
      SeriesInfoConstants.FETCH_SAME_SERIES_SUCCESS,
      SeriesInfoConstants.FETCH_SAME_SERIES_FAILURE
    ],
    apiRequest: (_state, client) => SeriesInfoApi.fetchSeriesInfo(metadataId, client)
  };
}

export { fetchSeriesInfo };
